(function($) {
  $(document).ready(function() {
    collection.init();
    window.collectionFilter = function(e) {
      delete Shopify.queryParams.constraint;
      delete Shopify.queryParams.q;
      Shopify.queryParams = {};
      collection.filterAjaxClick();
      e.preventDefault();
      $('.filter-tag a:not(".clear"), .filter-tag label').removeClass('active');
    }
  });
  if ($(".engoj-collection-sidebar")) {
    History.Adapter.bind(window, 'statechange', function() {
      var State = History.getState();
      if (!collection.fillterClick) {
        collection.filterParams();
        var newurl = collection.filterCreateUrl();
        collection.filterGetContent(newurl);
        collection.resetFilter();
      }
      collection.fillterClick = false;
    });
  }

  var collection = {
    init: function() {
      /* Collection Filter */
      this.initCollectionFilter();
	  /* Collection Sorting */
      this.initCollectionSorting();
    },

    /* Review */
    initReview: function() {
        // return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
    },
    /* Hide Dropdown */
    initToggle: function(){

    },

    /* Categories Fillter */
    filterCategories: function() {

    },

    fillterTagEvents: function() {
      $( "body" ).delegate( '.filter-tag a:not(".clear"), .filter-tag label', 'click',function(e) {
         /***新增start***/
         var dom = $(e.currentTarget)
         var domClass = dom.parent().parent().attr('class')
         var currCheckPrice = domClass.indexOf('list-price') > -1 ? true : false
         dom.parent().siblings().find('input').attr('checked', false)
         dom.parent().siblings().find('a').removeClass('active')
         /***新增end***/
        var sortingArr = []
        $(".collection-sorting li a").each(function(){
          sortingArr.push($(this).attr("data-title"))
        })
        if(sortingArr.indexOf(Shopify.queryParams.sort_by)<0){
          delete Shopify.queryParams.sort_by
        }
        const curClass1 = dom.attr('class').toString().indexOf('active') > -1 ? dom.attr('class').split('active')[0] : dom.attr('class');
        const curClass = curClass1.trim();
        $(this).toggleClass('active');
        var currentTags = [];
        /*
        if (Shopify.queryParams && Shopify.queryParams.constraint) {
            currentTags = Shopify.queryParams.constraint.split('+');
        }
        if (!window.filter_mul_choice && !$(this).prev().is(":checked")) {
            var otherTag = $(this).parents('.filter-tag').find("input:checked");
            if (otherTag.length > 0) {
                var tagName = otherTag.val();
                if (tagName) {
                  var tagPos = currentTags.indexOf(tagName);
                    if (tagPos >= 0) {
                        currentTags.splice(tagPos, 1);
                    }
                }
            }
        }
        */
        let isActive = dom.attr('class')
        //var tagName = $(this).prev().val();
        var tagName = $(this).prev().attr('filter_tag');
        const curTitle = $(this).attr('title');
        const parentTitle = dom.parents('.filter-tag').find('h2').text().trim();
        const changTitle = parentTitle+" : "+ curTitle;
        const lowerCaseTitle = parentTitle.toLocaleLowerCase();
        const filterName = 'filter_'+lowerCaseTitle+'_'+tagName;
        let htmlStr='<div class="filter-result-item '+curClass+'"   titlename='+lowerCaseTitle+' >'
                      +'<span class="filter-result-item-name" titlename='+filterName+'>'+changTitle+'</span>'
                      +'<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" width="14" height="14" fill="#212529" viewBox="0 0 298.667 298.667" style="enable-background:new 0 0 298.667 298.667;" xml:space="preserve">'
                      +'<g><g>'
                      +'<polygon points="298.667,30.187 268.48,0 149.333,119.147 30.187,0 0,30.187 119.147,149.333 0,268.48 30.187,298.667     149.333,179.52 268.48,298.667 298.667,268.48 179.52,149.333"></polygon>'
                      +'</g></g>'
                      +'</svg>'
                     +'</div>';
        if (tagName) {
            const findClass = '.'+curClass.toString()
            const isHaveClass = $('.collection-filter-result').find(findClass);
            $('.collection-filter-result').find('.filter-result-item[titlename='+lowerCaseTitle+']').remove();
            $('.collection-filter-result').show();
            if (isHaveClass.length == 0 && isActive.indexOf('active') > -1) {
              $('.collection-filter-result .clear-all').before(htmlStr);
            } else {
              isHaveClass.remove();
              if ( $('.collection-filter-result').children().length == 1) {
                $('.collection-filter-result').hide();
              }
            }
            if (tagName.indexOf('=') > 0){
               if (isActive.indexOf('active') > -1) {
                  currentTags.push(tagName);
               }else{
                 var tagValue = tagName.split('=')
                 if(Shopify.queryParams.hasOwnProperty(tagValue[0])){
                   delete Shopify.queryParams[tagValue[0]];
                 }
               }
            }else if(tagName.indexOf('-') > 0 && currCheckPrice){
               if (isActive.indexOf('active') > -1) {
                 currentTags.push(tagName);
               }else{
                if(Shopify.queryParams.hasOwnProperty('filter.v.price.gte')){
                  delete Shopify.queryParams['filter.v.price.gte'];
                }
                if(Shopify.queryParams.hasOwnProperty('filter.v.price.lte')){
                  delete Shopify.queryParams['filter.v.price.lte'];
                }
              }
            }
        }
        if (currentTags.length) {
             var arr = []
             for(var j in currentTags) {
               if (currentTags[j].indexOf('=') > 0){
                   var tagValue = currentTags[j].split('=')
                   var str = {
                       [tagValue[0]]: tagValue[1]
                   }
                   arr.push(str)
               }else{
                  var tagValue = currentTags[j].split('-')
                  if (tagValue.length > 0 && currCheckPrice) {
                     var str = {
                        'filter.v.price.gte': tagValue[0]+'.'+tagValue[1],
                        'filter.v.price.lte': tagValue[2]+'.'+tagValue[3]
                     }
                     arr.push(str)
                  }
               }
             }
            let changeArr =  arr.length > 0 ? { ...Shopify.queryParams, ...arr[0] } : { ...Shopify.queryParams }
            Shopify.queryParams = changeArr
        }
        collection.filterAjaxClick();
        e.preventDefault();
      });
    },

    filterMapClearAll: function() {
      //clear all selection
        $("body").delegate( '.refined-widgets a.clear-all','click', function(e) {
            delete Shopify.queryParams.constraint;
            delete Shopify.queryParams.q;
            collection.filterAjaxClick();
            e.preventDefault();
          	$('.filter-tag a:not(".clear"), .filter-tag label').removeClass('active');
        });

         $("body").delegate( '.filter-block .clear', 'click', function(e) {
              var currentTags = [];
              var filterTag = $(this).parent().parent();
              if (Shopify.queryParams.constraint) {
                  currentTags = Shopify.queryParams.constraint.split('+');
              }
              filterTag.find("input:checked").each(function() {
                  var selectedTag = $(this);
                  var tagName = selectedTag.val();
                  if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);
                      if (tagPos >= 0) {
                        //remove tag
                          currentTags.splice(tagPos, 1);
                      }
                  }
              });
              filterTag.find("a").each(function() {
                  $(this).removeClass("active");
              });
              if (currentTags.length) {
                 Shopify.queryParams.constraint = currentTags.join('+');
              } else {
                  delete Shopify.queryParams.constraint;
              }
              collection.filterAjaxClick();
              e.preventDefault();
          });
    },

    filterMapClear: function() {
      $(".filter-tag").each(function() {
        var filterTag = $(this);
        if (filterTag.find("input:checked").length > 0) {
          //has active tag
          filterTag.find(".clear").show().click(function(e) {
            var currentTags = [];
            if (Shopify.queryParams.constraint) {
              currentTags = Shopify.queryParams.constraint.split('+');
            }
            filterTag.find("input:checked").each(function() {
              var selectedTag = $(this);
              var tagName = selectedTag.val();
              if (tagName) {
                var tagPos = currentTags.indexOf(tagName);
                if (tagPos >= 0) {
                  //remove tag
                  currentTags.splice(tagPos, 1);
                }
              }
            });
            if (currentTags.length) {
              Shopify.queryParams.constraint = currentTags.join('+');
            } else {
              delete Shopify.queryParams.constraint;
            }
            collection.filterAjaxClick();
            e.preventDefault();
          });
        }
      });
    },

    filterParams: function() {
        Shopify.queryParams = {};
        if (location.search.length) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=');
                if (aKeyValue.length > 1) {
                    Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                }
            }
        }
    },

    filterMapEvents: function() {
        collection.fillterTagEvents();
    },

    resetFilter: function() {
        $(".filter-custom .active, .filter-links .active").removeClass("active");
        $(".filter-tag input:checked").attr("checked", false);
        //category
        var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
        if (cat && cat[1]) {
          $(".filter-links a[href='" + cat[0] + "']").addClass("active");
        }
    },

    filterMapData: function(data) {
        var currentList = $(".grid-uniform");
        var productList = $(data).find(".grid-uniform");
        currentList.replaceWith(productList);
        //replace paging
        if ($(".pagination").length > 0) {
          $(".pagination").replaceWith($(data).find(".pagination"));
        };

        $('.filter-blocks').replaceWith( $(data).find(".filter-blocks") );
        collection.filterMapClear();
      	//quickView();
        var ajaxCartConfig = {
          cartContainer: '.enj-minicart-ajax',
          addToCartSelector: '.enj-add-to-cart-btn',
          cartCountSelector: '.enj-cartcount',
          cartCostSelector: '.enj-cartcost',
          moneyFormat: null
        };
        jQuery(function($) {
          ajaxCart.init(ajaxCartConfig);
        });

        function loadmore() {
          $('.loadmore').children('a').on('click',function(e){
            $('.loadmore').addClass('d-none');
            $('.loading.tshopify-popup').addClass('active');
            var link = $('.loadmore').children('a').attr('href');
            if (link != '#' ) {
              $('.load-data').load(link+' .product-grid-view .row')
              setTimeout(function(){
                $('.load-data .js_loadmore').each(function(){$(this).appendTo('.product-grid-view .row')})
                //           $('.loadmore').appendTo('.collection_prod .product-grid-view row')
                $('.loadmore').eq(0).remove();
                loadmore();
                //quickView();
                var ajaxCartConfig = {
                  cartContainer: '.enj-minicart-ajax',
                  addToCartSelector: '.enj-add-to-cart-btn',
                  cartCountSelector: '.enj-cartcount',
                  cartCostSelector: '.enj-cartcost',
                  moneyFormat: null
                };
                  jQuery(function($) {
                  ajaxCart.init(ajaxCartConfig);
                });
                $('.loading.tshopify-popup').removeClass('active');
              },2000)
            } else {
              $('.loadmore').remove();
            }
            e.preventDefault();
          })
        }
        loadmore();

        jQuery('.engoj_select_color a').each(function(){
          jQuery(this).on("click",function(){
            var engoImage = jQuery(this).data('engojvariant-img');
            jQuery(this).parents('.engoj_grid_parent').find('.engoj_find_img img').attr({ src: engoImage });
            return false;
          });
        });
    },
    // 对象转换化url参数
    changeUrlParams: function (data) {
      var _result = [];
      for (var key in data) {
        var value = data[key];
        if (value.constructor == Array) {
          value.forEach(function(_value) {
            _result.push(key + "=" + _value);
          });
        } else {
          _result.push(key + '=' + value);
        }
      }
      return _result.join('&');
    },

    filterCreateUrl: function(baseLink) {
      var newQuery = collection.changeUrlParams(Shopify.queryParams) //$.param(Shopify.queryParams).replace(/%2B/g, '+');
      if (baseLink) {
        if (newQuery != "")
          return baseLink + "?" + newQuery;
        else
          return baseLink;
      }
      return location.pathname + "?" + newQuery;
    },

    filterAjaxClick: function(baseLink) {
      delete Shopify.queryParams.page;
      var newurl = collection.filterCreateUrl(baseLink);
      collection.fillterClick = true;
      History.pushState({
        param: Shopify.queryParams
      }, newurl, newurl);
      collection.filterGetContent(newurl);
    },

    filterGetContent: function(newurl) {
      $.ajax({
        type: 'get',
        url: newurl,
        beforeSend: function() {
          showPopup('.loading');
        },
        success: function(data) {
          collection.filterMapData(data);
          collection.filterMapClear();
          hidePopup('.loading');
          //hidePopup('.filter-to-left , .js-bg');

        },
        error: function(xhr, text) {
          hidePopup('.loading');
          //hidePopup('.filter-to-left, .js-bg');
          $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          showPopup('.ajax-error-modal');
        }
      });
    },

    initCollectionFilter: function() {
      if ($(".engoj-collection-sidebar").length > 0) {
        collection.filterParams();
        collection.filterMapEvents();
        collection.filterMapClear();
        collection.filterMapClearAll();
        const $checkDom = $(window).width() > 990 ? $('.content-page .filter_sidebar_general .filter-tag') : $('.filter-to-left .filter_sidebar .filter-tag');
        if (Shopify.queryParams && Shopify.queryParams['filter.v.price.gte'] && Shopify.queryParams['filter.v.price.lte']) {
           let shopify_filter_price = Shopify.queryParams['filter.v.price.gte'].replace(/\./g, "-")  + '-'  + Shopify.queryParams['filter.v.price.lte'].replace(/\./g, "-");
           $(".list-price-" + shopify_filter_price).addClass("active");
           const curClass = "list-price-" + shopify_filter_price;
           const $listPrice = $checkDom.find(".list-price-" + shopify_filter_price);
           this.filterHtmlCommon(curClass, $listPrice);
        }
        if (Shopify.queryParams && Shopify.queryParams['filter.v.option.farbe']) {
           let shopify_filter_color = Shopify.queryParams['filter.v.option.farbe'];
           $(".list-farbe-" + shopify_filter_color).addClass("active");
           const curClass = "list-farbe-" + shopify_filter_color;
           const $listPrice = $checkDom.find(".list-farbe-" + shopify_filter_color);
           this.filterHtmlCommon(curClass, $listPrice);
        }
        if (Shopify.queryParams && Shopify.queryParams['filter.v.option.material']) {
             let shopify_filter_material = Shopify.queryParams['filter.v.option.material'];
             shopify_filter_material = shopify_filter_material.replace('+', '-');
             $(".list-material-" + shopify_filter_material).addClass("active");
             const curClass = "list-material-" + shopify_filter_material;
             const $listPrice = $checkDom.find(".list-material-" + shopify_filter_material);
             this.filterHtmlCommon(curClass, $listPrice);
        }
        if (Shopify.queryParams && Shopify.queryParams['filter.v.option.stil']) {
           let shopify_filter_style = Shopify.queryParams['filter.v.option.stil'];
           shopify_filter_style = shopify_filter_style.replace('+', '-');
           $(".list-stil-" + shopify_filter_style).addClass("active");
           const curClass = "list-stil-" + shopify_filter_style;
           const $listPrice = $checkDom.find(".list-stil-" + shopify_filter_style);
           this.filterHtmlCommon(curClass, $listPrice);
        }
      }
    },

    filterHtmlCommon( curClass, $listPrice) {
       const curTitle = $listPrice.attr('title');
       const parentTitle = $listPrice.parents('.filter-tag').find('h2').text().trim();
       const changTitle = parentTitle+" : "+ curTitle;
       const lowerCaseTitle = parentTitle.toLocaleLowerCase();
       const tagName = $listPrice.prev().attr('filter_tag');
       const filterName = 'filter_'+lowerCaseTitle+'_'+tagName;
       let htmlStr='<div class="filter-result-item '+curClass+'"   titlename='+lowerCaseTitle+' >'
                  +'<span class="filter-result-item-name" titlename='+filterName+'>'+changTitle+'</span>'
                  +'<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" width="14" height="14" fill="#212529" viewBox="0 0 298.667 298.667" style="enable-background:new 0 0 298.667 298.667;" xml:space="preserve">'
                  +'<g><g>'
                  +'<polygon points="298.667,30.187 268.48,0 149.333,119.147 30.187,0 0,30.187 119.147,149.333 0,268.48 30.187,298.667     149.333,179.52 268.48,298.667 298.667,268.48 179.52,149.333"></polygon>'
                  +'</g></g>'
                  +'</svg>'
                 +'</div>';
      $('.collection-filter-result .clear-all').before(htmlStr);
    },

    /* Collection Sorting */
    initCollectionSorting: function(e) {
      $(".collection-sorting a").click(function(e) {
        e.preventDefault();
        if (!$(this).parent().hasClass("active")) {
          Shopify.queryParams.sort_by = $(this).attr("data-title");
          collection.filterAjaxClick();
          $(".collection-sorting li.active").removeClass("active");
          $(this).parent().addClass("active");
        }
        var selected = $(this).text();
        $(this).closest('.dropdown').find('.dropdown-label').text(selected);
        $(this).closest('.dropdown-content').removeClass('active');
      });
    },
    /* Collection View Mode */
    initCollectionViewMode: function() {

    },
    /* Collection Show */
    initCollectionShow: function() {

    },
    /* Paging */
    initPaging: function() {

    },
  }
})(jQuery);